import { Box } from "@mui/material";

import styled from "styled-components";

export const PaginationWrap = styled(Box)<{ $standalone?: boolean }>`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    flex-wrap: wrap;
    font-family: "Nunito", sans-serif;

    ${({ $standalone }) =>
        $standalone
            ? `
        background: #ffffff;
        border: 1px solid rgba(0, 0, 0, 0.05);
        border-radius: 10px;
        padding: 16px 24px;
    `
            : `
        position: sticky;
        bottom: 0;
        z-index: 2;
        padding: 12px 20px;
        border-top: 1px solid #f0f0f2;
        background: #ffffff;
        box-shadow: 0 -6px 12px -8px rgba(0, 0, 0, 0.08);
    `}

    @media (max-width: 640px) {
        justify-content: center;
    }
`;

export const PaginationInfoSection = styled(Box)`
    flex: 1;
    display: flex;
    justify-content: flex-start;
    min-width: 160px;

    @media (max-width: 640px) {
        order: 2;
        justify-content: center;
        flex: none;
    }
`;

export const ResultsText = styled(Box)`
    font-size: 12px;
    color: #86868b;
    white-space: nowrap;

    strong {
        color: #1d1d1f;
        font-weight: 700;
    }
`;

export const PaginationCenterSection = styled(Box)`
    flex: 0 0 auto;
    display: flex;
    justify-content: center;

    @media (max-width: 640px) {
        order: 1;
    }
`;

export const PaginationControls = styled(Box)`
    display: flex;
    align-items: center;
    gap: 4px;
`;

export const PageNavButton = styled(Box)<{ $disabled?: boolean }>`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 30px;
    height: 30px;
    padding: 0 4px;
    border-radius: 8px;
    border: 1px solid #e5e5ea;
    background: #ffffff;
    color: ${({ $disabled }) => ($disabled ? "#c7c7cc" : "#1d1d1f")};
    cursor: ${({ $disabled }) => ($disabled ? "default" : "pointer")};
    pointer-events: ${({ $disabled }) => ($disabled ? "none" : "auto")};
    transition:
        border-color 150ms ease,
        color 150ms ease;

    &:hover {
        border-color: #ed6c02;
        color: #ed6c02;
    }

    svg {
        font-size: 18px;
    }
`;

export const PageNumberButton = styled(Box)<{ $active?: boolean }>`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 30px;
    height: 30px;
    padding: 0 6px;
    border-radius: 8px;
    border: 1px solid ${({ $active }) => ($active ? "#ed6c02" : "#e5e5ea")};
    background: ${({ $active }) => ($active ? "#ed6c02" : "#ffffff")};
    color: ${({ $active }) => ($active ? "#ffffff" : "#1d1d1f")};
    font-size: 13px;
    font-weight: ${({ $active }) => ($active ? 700 : 600)};
    cursor: pointer;
    user-select: none;
    transition:
        border-color 150ms ease,
        background 150ms ease,
        color 150ms ease;

    &:hover {
        border-color: #ed6c02;
        ${({ $active }) => (!$active ? "color: #ed6c02;" : "")}
    }
`;

export const PaginationEllipsis = styled(Box)`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 30px;
    height: 30px;
    color: #aeaeb2;
`;

export const PaginationSizeSection = styled(Box)`
    flex: 1;
    display: flex;
    justify-content: flex-end;
    min-width: 120px;

    @media (max-width: 640px) {
        order: 3;
        justify-content: center;
        flex: none;
    }
`;

export const PageSizeBox = styled(Box)`
    display: flex;
    align-items: center;
    gap: 8px;

    & .MuiOutlinedInput-root {
        height: 30px;
        border-radius: 8px;
        font-size: 13px;
    }

    & .MuiSelect-select {
        padding: 4px 28px 4px 10px !important;
        min-width: 20px;
        box-sizing: content-box;
    }

    & .MuiSelect-icon {
        right: 4px;
    }
`;

export const PageSizeLabel = styled(Box)`
    font-size: 12px;
    color: #86868b;
    white-space: nowrap;
`;
